module.exports = __webpack_public_path__ + "static/media/8.57dd0b2e.svg";